import { createChatProvider, createEmbedProvider, createModelProvider, merge } from '@xsai-ext/providers/utils'
import { z } from 'zod'

import { createOpenAICompatibleValidators } from '../../validators/openai-compatible'
import { defineProvider } from '../registry'

const aihubmixConfigSchema = z.object({
  apiKey: z
    .string('API Key'),
  baseUrl: z
    .string('Base URL')
    .optional()
    .default('https://aihubmix.com/v1/'),
})

type AIHubMixConfig = z.input<typeof aihubmixConfigSchema>

export const providerAIHubMix = defineProvider<AIHubMixConfig>({
  id: 'aihubmix',
  order: 1,
  name: 'AIHubMix',
  nameLocalize: ({ t }) => t('settings.pages.providers.provider.aihubmix.title'),
  description: 'AIHubMix',
  descriptionLocalize: ({ t }) => t('settings.pages.providers.provider.aihubmix.description'),
  tasks: ['chat'],
  icon: 'i-lobe-icons:aihubmix',
  iconColor: 'i-lobe-icons:aihubmix-color',

  createProviderConfig: ({ t }) => aihubmixConfigSchema.extend({
    apiKey: aihubmixConfigSchema.shape.apiKey.meta({
      labelLocalized: t('settings.pages.providers.catalog.edit.config.common.fields.field.api-key.label'),
      descriptionLocalized: t('settings.pages.providers.catalog.edit.config.common.fields.field.api-key.description'),
      placeholderLocalized: t('settings.pages.providers.catalog.edit.config.common.fields.field.api-key.placeholder'),
      type: 'password',
    }),
    baseUrl: aihubmixConfigSchema.shape.baseUrl.meta({
      labelLocalized: t('settings.pages.providers.catalog.edit.config.common.fields.field.base-url.label'),
      descriptionLocalized: t('settings.pages.providers.catalog.edit.config.common.fields.field.base-url.description'),
      placeholderLocalized: t('settings.pages.providers.catalog.edit.config.common.fields.field.base-url.placeholder'),
    }),
  }),
  createProvider(config) {
    return merge(
      createChatProvider({ apiKey: config.apiKey, baseURL: config.baseUrl! }),
      createEmbedProvider({ apiKey: config.apiKey, baseURL: config.baseUrl! }),
      createModelProvider({ apiKey: config.apiKey, baseURL: config.baseUrl! }),
    )
  },

  validationRequiredWhen(config) {
    return !!config.apiKey?.trim()
  },
  validators: {
    ...createOpenAICompatibleValidators({
      checks: ['model_list'],
    }),
  },
})
